import { triggerSubmissionEventFromSessionStorage } from "@src/analytics";

import "./index.css";

export function setupThankYou() {
  const container = document.querySelector(".container-thank-you");

  if (container == null) {
    return;
  }

  triggerSubmissionEventFromSessionStorage();
}
